import {Form, Select, Spin} from "antd";
import {useEffect, useMemo, useState} from "react";
import {getArgList} from "@/services/product.ts";
import {isEmpty} from "lodash-es";

type IProps = {
  formRef: any;
  addInputArg?: Array<any>;
  editId?: string,
  editIdList?: Array<any>;
  multiple?: boolean,
  fn: (data: any[], editId: string | Array<any>) => void,
}

export const InputSpecsModal = (props: IProps) => {
  const { fn, formRef, addInputArg = [], editId = '', multiple = false, editIdList = [] } = props;

  const [form] = Form.useForm()
  const [option, setOption] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getOptions()
  }, []);
  
  useEffect(() => {
    if (Array.isArray(addInputArg) && addInputArg.length && !multiple) {
      form.setFieldValue('product', addInputArg?.map(item => item.argCode))
    }
  }, [addInputArg])

  const getOptions = async () => {
    try {
      setLoading(true)
      const list: any = await getArgList({enabled: true});
      if (!Array.isArray(list)) {
        return;
      }
      setOption(list?.filter((item: any) => item.argType === 'INPUT')?.map(item => ({
        ...item,
        label: item.argName,
        value: item.argCode,
        type: item.argType,
        data: item.argValueJson?.list  || undefined
      })));
      setLoading(false)
    }catch (e){
      setLoading(false)
    }
  }

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      form.validateFields().then(values => {
        console.log(values)
        const argList = option.filter(item => values?.product?.includes(item.argCode))
        if (!multiple) {
          fn(argList || [], editId)
        } else {
          fn(argList || [], editIdList)
        }
        resolve(values)
      }).catch(reject);
    })
  }

  if (formRef) {
    formRef.current.onFinish = onFinish;
  }

  return <Form form={form} layout={'vertical'}>
    <Spin spinning={loading}>
      <Form.Item name={'product'} label={'产品参数'}>
        <Select placeholder={'请选择产品参数'} mode={'multiple'} optionFilterProp={'label'} options={option}/>
      </Form.Item>
    </Spin>
  </Form>
}

